// statsService.js
// Service for statistics-related API calls: team stats, player stats, insights, injuries

import { POST, GET, BASE_URL } from './httpClient';

/**
 * Statistics and insights functions
 */

// Function to get team statistics
export const getTeamStats = async (teamId, sport) => {
    try {
        const response = await POST(`${BASE_URL}/stats/team-stats`, {
            teamId: teamId,
            sport: sport
        });
        return response;
    } catch (error) {
        console.error('Error fetching team stats:', error);
        throw error;
    }
};

// Function to get player statistics
export const getPlayerStats = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/stats/player-stats`, request);
        return response;
    } catch (error) {
        console.error('Error fetching player stats:', error);
        throw error;
    }
};

// Function to get players list
export const getPlayers = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/stats/players`, request);
        return response;
    } catch (error) {
        console.error('Error fetching players:', error);
        throw error;
    }
};

// Function to get matchup insights
export const getMatchupInsights = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/stats/match-up-insights`, request);
        return response;
    } catch (error) {
        console.error('Error fetching matchup insights:', error);
        throw error;
    }
};

// Function to get player prop insights
export const getPlayerPropInsights = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/stats/player-prop-insights`, request);
        return response;
    } catch (error) {
        console.error('Error fetching player prop insights:', error);
        throw error;
    }
};

// Function to get matchup injuries
export const getMatchupInjuries = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/stats/injuries`, request);
        return response;
    } catch (error) {
        console.error('Error fetching matchup injuries:', error);
        throw error;
    }
};

